import { style } from '@vanilla-extract/css'

const warn = style({
  textAlign: 'center',
  fontSize: '13px',
  lineHeight: '1.5',
  letterSpacing: '0.02em',
  color: '#ED0006',
})

export const styles = {
  warn,
}
